import OperationsPageShell from '../components/OperationsPageShell';

const routes = [
  { route: 'R-101', status: 'Active', vehicle: 'TRK-02', driver: 'John M.', progress: '76%' },
  { route: 'R-204', status: 'Delayed', vehicle: 'TRK-07', driver: 'Asha K.', progress: '42%' },
  { route: 'R-310', status: 'Completed', vehicle: 'TRK-13', driver: 'Ezra N.', progress: '100%' },
];

const statusClassMap: Record<string, string> = {
  Active: 'badge-light-success',
  Delayed: 'badge-light-warning',
  Completed: 'badge-light-primary',
};

const RouteManagement = () => (
  <OperationsPageShell
    title="Route Management"
    subtitle="Route status, assignment health, and in-flight progress."
    action={
      <button type="button" className="uw-btn uw-btn-light uw-btn-sm btn btn-sm btn-light">
        ↻ Refresh
      </button>
    }
  >
    <div className="table-responsive">
      <table className="table align-middle gs-0 gy-4">
        <thead>
          <tr>
            <th>Route</th>
            <th>Status</th>
            <th>Vehicle</th>
            <th>Driver</th>
            <th>Progress</th>
          </tr>
        </thead>
        <tbody>
          {routes.map((route) => (
            <tr key={route.route}>
              <td>{route.route}</td>
              <td>
                <span className={`badge ${statusClassMap[route.status] || 'badge-light-secondary'}`}>
                  {route.status}
                </span>
              </td>
              <td>{route.vehicle}</td>
              <td>{route.driver}</td>
              <td>{route.progress}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </OperationsPageShell>
);

export default RouteManagement;
